import { useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';
export function useAuth() {
    const ctx = useContext(AuthContext);
    return {
        ...ctx,
        isSuperAdmin: ctx.user?.roles.includes('ROLE_SUPER_ADMIN') ?? false,
        isAdminCommune: ctx.user?.roles.includes('ROLE_ADMIN_COMMUNE') ?? false,
    };
}
